import React, {useEffect, useRef, useState} from 'react';

import './PlayedCard.css';

import {useTypedSelector} from "../../../hooks/useTypedSelector";
import Card from "../../card/Card";
import TargetAnimations from "./target_animations/TargetAnimations";
import {useActions} from "../../../hooks/useActions";
import {ITae} from "../../../models/game/ITae";
import {config} from "../../../config";


function PlayedCard() {

    const {cpuPlayedCard, phase, playedCard} = useTypedSelector(state => state.game);
    const {coords} = useTypedSelector(state => state.animation);
    const {setCoords} = useActions();
    const elementRef = useRef(null);

    let card = null;

    if (cpuPlayedCard.card !== null) {
        // @ts-ignore
        card = cpuPlayedCard.card;
    }

    if ((phase === 'select_unit_target' || phase === 'select_spell_target') && playedCard.card !== null) {
        // @ts-ignore
        card = playedCard.card;
    }

    let rootClasses = 'playedCardContainer';
    if (card !== null) {
        rootClasses += ' playedCardContainerActive';
    }

    const [showCanvas, setShowCanvas] = useState(false);

    useEffect(() => {
        // коли card змінюється — запускаємо таймер
        if (card !== null) {
            const timer = setTimeout(() => {
                setShowCanvas(true);
            }, 300);

            return () => clearTimeout(timer); // cleanup
        } else {
            setShowCanvas(false);
        }
    }, [card]);

    useEffect(() => {
        if (elementRef.current) {
            // @ts-ignore
            const rect = elementRef.current.getBoundingClientRect();

            if(!rect){
                return;
            }
            const key = 'played_card_container' ;

            let elementCoords;
            if(config.isWindows && window.devicePixelRatio > 1) {

                let modulator = 1 + (window.devicePixelRatio - 1) * 0.65;
                modulator = Math.round(modulator * 100) / 100;

                elementCoords = {
                    x: Math.round(rect.left + rect.width / 2) * modulator,
                    y: Math.round(rect.top + rect.height / 2) * modulator,
                }
            }else{
                elementCoords = {
                    x: Math.round(rect.left + rect.width / 2),
                    y: Math.round(rect.top + rect.height / 2),
                }
            }
            coords[key] = elementCoords;

            setCoords(coords);
        }
    }, [rootClasses]);

    return (
        <div className={rootClasses}>
            {showCanvas &&
            card !== null &&
            cpuPlayedCard.target &&
            cpuPlayedCard.card?.ability?.tae ? (
                <TargetAnimations
                    targetData={cpuPlayedCard.target}
                    tae={cpuPlayedCard.card?.ability.tae as unknown as ITae}
                />
            ) : (
                <div></div>
            )
            }
            <div ref={elementRef} className={'playedCardContainerSmall'}>
                    {card !== null ? (
                        <Card  card={card} isBigSize={true} />
                    ) : (
                        <div></div>
                    )}

            </div>
        </div>
    );
}

export default PlayedCard;
